import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_633fc888 from 'nuxt_plugin_plugin_633fc888' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_267dbb70 from 'nuxt_plugin_plugin_267dbb70' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_image_66a906ce from 'nuxt_plugin_image_66a906ce' // Source: ./image.js (mode: 'all')
import nuxt_plugin_gtm_655c95f4 from 'nuxt_plugin_gtm_655c95f4' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_webfontloader_0f9970c4 from 'nuxt_plugin_webfontloader_0f9970c4' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_pluginutils_004d4346 from 'nuxt_plugin_pluginutils_004d4346' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_24fbc868 from 'nuxt_plugin_pluginrouting_24fbc868' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_135f87f2 from 'nuxt_plugin_pluginmain_135f87f2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_storage_4e04678e from 'nuxt_plugin_storage_4e04678e' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_workbox_e758f58c from 'nuxt_plugin_workbox_e758f58c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6fd8f24d from 'nuxt_plugin_metaplugin_6fd8f24d' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_748097c1 from 'nuxt_plugin_iconplugin_748097c1' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_3cb700c4 from 'nuxt_plugin_axios_3cb700c4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_routerewriteclient_735d66e6 from 'nuxt_plugin_routerewriteclient_735d66e6' // Source: ../plugins/route-rewrite.client.ts (mode: 'client')
import nuxt_plugin_routerewriteserver_4dd24f24 from 'nuxt_plugin_routerewriteserver_4dd24f24' // Source: ../plugins/route-rewrite.server.ts (mode: 'server')
import nuxt_plugin_api_7852046e from 'nuxt_plugin_api_7852046e' // Source: ../plugins/api.ts (mode: 'all')
import nuxt_plugin_utils_1ea76652 from 'nuxt_plugin_utils_1ea76652' // Source: ../plugins/utils.ts (mode: 'all')
import nuxt_plugin_vuelazyload_d07c1ad4 from 'nuxt_plugin_vuelazyload_d07c1ad4' // Source: ../plugins/vue-lazyload.ts (mode: 'all')
import nuxt_plugin_vueawesomeswiper_5ce0408e from 'nuxt_plugin_vueawesomeswiper_5ce0408e' // Source: ../plugins/vue-awesome-swiper.ts (mode: 'client')
import nuxt_plugin_floatingvue_09851550 from 'nuxt_plugin_floatingvue_09851550' // Source: ../plugins/floating-vue.ts (mode: 'client')
import nuxt_plugin_vueimagezoomer_2362c3fe from 'nuxt_plugin_vueimagezoomer_2362c3fe' // Source: ../plugins/vue-image-zoomer.ts (mode: 'client')
import nuxt_plugin_vuestarrating_daf0785c from 'nuxt_plugin_vuestarrating_daf0785c' // Source: ../plugins/vue-star-rating.ts (mode: 'client')
import nuxt_plugin_gmapvue_694aabe9 from 'nuxt_plugin_gmapvue_694aabe9' // Source: ../plugins/gmap-vue.ts (mode: 'client')
import nuxt_plugin_datalayer_6026d85c from 'nuxt_plugin_datalayer_6026d85c' // Source: ../plugins/datalayer.ts (mode: 'client')
import nuxt_plugin_meta_4b049afc from 'nuxt_plugin_meta_4b049afc' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"name":"format-detection","content":"telephone=no"}],"noscript":[{"hid":"universal-noscript","pbody":true,"innerHTML":"\u003Cdiv class=\"fixed inset-0 z-100 bg-white flex flex-col justify-center items-center p-4\"\u003E\u003Ch2 class=\"font-bold py-5 text-3xl\"\u003EJavaScript is Disabled\u003C\u002Fh2\u003E\u003Cp\u003EPlease enable javascript and refresh the page\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E"},{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"universal-noscript":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"script":[{"src":"https:\u002F\u002Fwidget.thuiswinkel.org\u002Fscript.js?id=MTI1MC0x","async":true,"defer":false},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com"},{"rel":"preconnect","href":"https:\u002F\u002Fuse.typekit.net"},{"rel":"preload","href":"https:\u002F\u002Fuse.typekit.net\u002Fhgw4npy.css","as":"style"},{"rel":"preload","as":"font","type":"font\u002Fotf","href":"https:\u002F\u002Fuse.typekit.net\u002Faf\u002F2cd6bf\u002F00000000000000000001008f\u002F27\u002Fa?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fotf","href":"https:\u002F\u002Fuse.typekit.net\u002Faf\u002F9b05f3\u002F000000000000000000013365\u002F27\u002Fa?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fotf","href":"https:\u002F\u002Fuse.typekit.net\u002Faf\u002Fc4c302\u002F000000000000000000012192\u002F27\u002Fa?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fotf","href":"https:\u002F\u002Fuse.typekit.net\u002Faf\u002F053fc9\u002F00000000000000003b9af1e4\u002F27\u002Fa?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3","crossorigin":true}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_633fc888 === 'function') {
    await nuxt_plugin_plugin_633fc888(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_267dbb70 === 'function') {
    await nuxt_plugin_plugin_267dbb70(app.context, inject)
  }

  if (typeof nuxt_plugin_image_66a906ce === 'function') {
    await nuxt_plugin_image_66a906ce(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_655c95f4 === 'function') {
    await nuxt_plugin_gtm_655c95f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_0f9970c4 === 'function') {
    await nuxt_plugin_webfontloader_0f9970c4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_004d4346 === 'function') {
    await nuxt_plugin_pluginutils_004d4346(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_24fbc868 === 'function') {
    await nuxt_plugin_pluginrouting_24fbc868(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_135f87f2 === 'function') {
    await nuxt_plugin_pluginmain_135f87f2(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_4e04678e === 'function') {
    await nuxt_plugin_storage_4e04678e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_e758f58c === 'function') {
    await nuxt_plugin_workbox_e758f58c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6fd8f24d === 'function') {
    await nuxt_plugin_metaplugin_6fd8f24d(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_748097c1 === 'function') {
    await nuxt_plugin_iconplugin_748097c1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3cb700c4 === 'function') {
    await nuxt_plugin_axios_3cb700c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routerewriteclient_735d66e6 === 'function') {
    await nuxt_plugin_routerewriteclient_735d66e6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_routerewriteserver_4dd24f24 === 'function') {
    await nuxt_plugin_routerewriteserver_4dd24f24(app.context, inject)
  }

  if (typeof nuxt_plugin_api_7852046e === 'function') {
    await nuxt_plugin_api_7852046e(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_1ea76652 === 'function') {
    await nuxt_plugin_utils_1ea76652(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_d07c1ad4 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1ad4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_5ce0408e === 'function') {
    await nuxt_plugin_vueawesomeswiper_5ce0408e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_floatingvue_09851550 === 'function') {
    await nuxt_plugin_floatingvue_09851550(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueimagezoomer_2362c3fe === 'function') {
    await nuxt_plugin_vueimagezoomer_2362c3fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestarrating_daf0785c === 'function') {
    await nuxt_plugin_vuestarrating_daf0785c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gmapvue_694aabe9 === 'function') {
    await nuxt_plugin_gmapvue_694aabe9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datalayer_6026d85c === 'function') {
    await nuxt_plugin_datalayer_6026d85c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_4b049afc === 'function') {
    await nuxt_plugin_meta_4b049afc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
